import getDiffMinutes from "../../utils/date"
import { StringsSessionStorage, temValor } from "../../utils/global"
import { loginService } from "../Login-Service/login-service"

export const customAuthorizationMiddleware = (request: any) => {
    const MINUTOS_RESTANTES_PARA_EXECUTAR_RENEWTOKEN = 30
    if (request.baseURL === process.env.REACT_APP_BASEURL_API && request.url.indexOf("validarusuario") === -1 &&
        request.url.indexOf("getdominios") === -1) {                
        if (request.url.indexOf("renewToken") === -1 && !temValor(sessionStorage.getItem(StringsSessionStorage.RequestRenewToken))) {                        
            const MINUTOS_RESTANTES_EXPIRACAO_TOKEN = getDiffMinutes(new Date(), new Date(sessionStorage.getItem(StringsSessionStorage.ExpirationToken) || "" ))            
            if (MINUTOS_RESTANTES_EXPIRACAO_TOKEN <= MINUTOS_RESTANTES_PARA_EXECUTAR_RENEWTOKEN) {
                sessionStorage.setItem(StringsSessionStorage.RequestRenewToken,"true")
                loginService.renewToken().then(()=>sessionStorage.removeItem(StringsSessionStorage.RequestRenewToken))
            }
        }

        request.headers["Custom-Authorization"] = sessionStorage.getItem(StringsSessionStorage.CustomToken)
        //request.headers["Custom-Authorization"] = getCookie(StringsCookie.CustomToken)
    }

    return request
}